var map = {
	"./pages/administrativo/actividades/actividades.module": [
		"./src/app/pages/administrativo/actividades/actividades.module.ts",
		"common",
		"actividades.module"
	],
	"./pages/administrativo/asignaturas-areas/asignaturas-areas.module": [
		"./src/app/pages/administrativo/asignaturas-areas/asignaturas-areas.module.ts",
		"common",
		"asignaturas-areas.module"
	],
	"./pages/administrativo/asignaturas/asignaturas.module": [
		"./src/app/pages/administrativo/asignaturas/asignaturas.module.ts",
		"common",
		"asignaturas.module"
	],
	"./pages/administrativo/docentes/docentes.module": [
		"./src/app/pages/administrativo/docentes/docentes.module.ts",
		"common",
		"docentes.module"
	],
	"./pages/administrativo/pensum/pensum.module": [
		"./src/app/pages/administrativo/pensum/pensum.module.ts",
		"common",
		"pensum.module"
	],
	"./pages/administrativo/reportes/reportes.module": [
		"./src/app/pages/administrativo/reportes/reportes.module.ts",
		"reportes.module.0"
	],
	"./pages/authentication/authentication.module": [
		"./src/app/pages/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./pages/colecturia/cartera/cartera.module": [
		"./src/app/pages/colecturia/cartera/cartera.module.ts",
		"common",
		"cartera.module"
	],
	"./pages/colecturia/colecturia.module": [
		"./src/app/pages/colecturia/colecturia.module.ts",
		"common",
		"colecturia.module"
	],
	"./pages/configuracion/usuarios/usuarios.module": [
		"./src/app/pages/configuracion/usuarios/usuarios.module.ts",
		"common",
		"usuarios.module"
	],
	"./pages/dashboard/dashboard-default/dashboard-default.module": [
		"./src/app/pages/dashboard/dashboard-default/dashboard-default.module.ts",
		"dashboard-default.module"
	],
	"./pages/email/email.module": [
		"./src/app/pages/email/email.module.ts",
		"email.module"
	],
	"./pages/procesos-academicos/asignacion-cursos/asignacion-cursos.module": [
		"./src/app/pages/procesos-academicos/asignacion-cursos/asignacion-cursos.module.ts",
		"asignacion-cursos.module"
	],
	"./pages/procesos-academicos/importar-fotos/importar-fotos.module": [
		"./src/app/pages/procesos-academicos/importar-fotos/importar-fotos.module.ts",
		"importar-fotos.module"
	],
	"./pages/procesos-academicos/inscripciones/inscripciones.module": [
		"./src/app/pages/procesos-academicos/inscripciones/inscripciones.module.ts",
		"inscripciones.module"
	],
	"./pages/procesos-academicos/matriculas/matriculas.module": [
		"./src/app/pages/procesos-academicos/matriculas/matriculas.module.ts",
		"common",
		"matriculas.module"
	],
	"./pages/procesos-academicos/pase-anio/pase-anio.module": [
		"./src/app/pages/procesos-academicos/pase-anio/pase-anio.module.ts",
		"pase-anio.module"
	],
	"./pages/registro-calificacion/calificaciones.module": [
		"./src/app/pages/registro-calificacion/calificaciones.module.ts",
		"calificaciones.module"
	],
	"./pages/reportes/reportes.module": [
		"./src/app/pages/reportes/reportes.module.ts",
		"reportes.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main